// Angular
import { AfterViewInit, Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
// RxJS
import { Subscription, of } from 'rxjs';
// Layout
import { SubheaderService } from '../../../../../core/_base/layout';
import { Breadcrumb } from '../../../../../core/_base/layout/services/subheader.service';
import { ActivatedRoute, Router, NavigationEnd, RoutesRecognized, ActivationEnd } from '@angular/router';
import { AppService } from '../../../../../services/app.service';
import { UtilitaryService } from '../../../../../services/utilitary.service';
import { StateService } from '../../../../../services/state.service';
import * as _ from 'lodash';
import { CourrierDialog } from '../../dialog/courrier-dialog.component';
import { FormDialogFormulaireWithSFComponent } from '../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf.component';

import { ConfirmComponent } from '../../dialog/confirm.component';
import { AccesComponent } from '../../dialog/acces.component';
import { DoublonComponent } from '../../dialog/doublon.component';
import { MatSnackBar } from '@angular/material';
import { first } from 'rxjs/operators';
import { DemandeInstructionDialogComponent } from '../../dialog/demande-instruction-dialog.component';
@Component({
	selector: 'kt-subheader3',
	templateUrl: './subheader3.component.html',
	styleUrls: ['./subheader3.component.scss']
})
export class Subheader3Component implements OnInit, OnDestroy, AfterViewInit {
	// Public properties
	droits: any = [];
	userDroits: any = [];
	user: any;
	today: number = Date.now();
	title: string = '';
	desc: string = '';
	desc2: string;
	
	breadcrumbs: Breadcrumb[] = [];
	colorization: string = '';
	quickmenu: any[] = [];
	etats: any[] = [];
	url: string = '';
	id: string = '';
	currentState: any;

	demande: any;
	dossier: any;
	dossierWeb: any;
	getCourrierFunc: any;
	getImpressionFunc: any;
	returnToDossierFunc: any;
	createInstructionCompFunc: any;
	creationForm: any;
	creationFormDossierFunc: any;
	creationFormMAMDossierFunc: any;
	goToURL: any;
	creationInstruction: any;
	archiveDossier: any;
	doublonDossier: any;
	showAcces: any;
	labelSub: any = "Actions";
	displayAlerts: boolean = false;
	// Private properties
	private subscriptions: Subscription[] = [];

	icon:any;
	dossierTitle: any;
	/**
	 * Component constructor
	 *
	 * @param subheaderService: SubheaderService
	 */
	constructor(
		private activatedRoute: ActivatedRoute,
		public subheaderService: SubheaderService,
		private router: Router,
		private appService: AppService,
		private stateService: StateService,
		public dialog: MatDialog,
		private cdf: ChangeDetectorRef,
		private utilities: UtilitaryService,
		private snackBar : MatSnackBar
		) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		/*this.stateService.icon.subscribe((icon:any) => {
					console.log("Subheader3Component init icon",icon)
					this.icon=icon;
		})
		*/
		
		
		
		this.stateService.pages.subscribe((pages)=> {
			let routeConfig = '';
			this.router.events.subscribe((res) => {
				this.quickmenu = [];
				let _params={}
				if (res instanceof NavigationEnd) {
					routeConfig = this.activatedRoute.firstChild.routeConfig.path;
					this.stateService.components.pipe(first()).subscribe((res) => {
						res.forEach(element => {
							if(element.name === "DossierPageComponent"){
								if(element.component === this.activatedRoute.firstChild.routeConfig.component)
									this.displayAlerts = true;
								else
									this.displayAlerts = false;
							}
						});
						
						
						                    
	                    this.activatedRoute.firstChild.params.subscribe(params => {
	                       _params=params;
	                       
	                    });
						
					});
					
					let grpButton=[];
					let grpWithoutButton=[];
					// Hide loading indicator
					if(pages.length > 0){
						
						
						
						pages.forEach((page) => {
							if(page.url === routeConfig){
								console.log("Subheader3Component actions",page.actions,_params);
								page.actions.forEach((action: any) => {
														                   //  console.log("action",action.tiers_type,routeConfig,_params)
				                   if (action.sous_groupe) {
				                      
				                       if (grpButton[action.sous_groupe]==undefined)
				                           grpButton[action.sous_groupe]={
				                                        libelle:  action.sous_groupe,
				                                        children:[],
				                                        link: 'etats'
				                            };
				                   } 
								});   
								
								page.actions.forEach((action) => {
									let button = action;
									if(button.type == "action" && button.parametre.action == "createForm"){
										button.action = () => {
											return this.creationForm(button.parametre.type, (button.parametre.options ? button.parametre.options : ''))
										};
									}
									else if(button.type == "action" && button.parametre.action == "createInstruction"){
										button.action = () => {
											return this.creationInstruction(button.parametre.type, (button.parametre.options ? button.parametre.options : ''));
										}
									}
									else if(button.type == "action" && button.parametre.action == "showAcces"){
										button.action = () => {
											return this.showAcces();
										}
									}
									else if(button.type == "action" && button.parametre.action == "doublon"){
										button.action = () => {
											return this.doublonDossier();
										}
									}
									else if(button.type == "action" && button.parametre.action == "archivage"){
										button.action = () => {
											return this.archiveDossier((button.parametre.options && button.parametre.options.retour ? button.parametre.options.retour : ''), (button.parametre.options && button.parametre.options ? button.parametre.options : ''));
										}
									}
									else if(button.type == "link")
										button.action = () => {
											return this.goToURL(button.parametre.url);
										}
									if (this.checkToAddButton(action,_params))	{	
										  if (button.sous_groupe &&
		                            			grpButton[button.sous_groupe]!=undefined) {
                            				grpButton[button.sous_groupe].children.push(button)
					                       } else
					                            grpWithoutButton.push(button)										
										//this.quickmenu.push(button);
									}							
								});
							}
						});
					}
					console.log("Subheader3Component grpButton",grpButton,grpWithoutButton )
					        this.quickmenu=grpWithoutButton;
					        
					       Object.values(grpButton).forEach((value: any) => {
					          //console.log("grpButton",value);
					          this.quickmenu.push(value);    
					        });
					 console.log("Subheader3Component quickmenu",this.quickmenu);
				
				}
			});
		})
		this.creationForm = (type, page) => {
			if(page.confirm){
				const confDialogRef = this.dialog.open(ConfirmComponent, {});
				confDialogRef.afterClosed().subscribe(res => {
				  if(res === 'true')
					  this.getFormulaire(type, page);
			  	});
			}
			else
				this.getFormulaire(type, page);
		}
		this.goToURL = (url) => {
			this.router.navigate(['/home/'+url]);
		}
		
		this.stateService.dossierWebamat.subscribe((dossier) => {
			this.dossierWeb = dossier;
			this.doublonDossier = () => {
				this.displayDoublon();
			}
		});
		this.stateService.demande.subscribe((demande) => {
			this.demande = demande;
			this.getCourrierFunc = () => {
				this.getCourrier(demande.ID, this.currentState.typeForm)
			};
			this.getImpressionFunc = () => {
				let formPrint;
				_.forEach(demande.forms, (form, index) => {
					if(form.key === this.currentState.typeForm)
						formPrint = form
				})
				this.getImpression(this.currentState.typeForm, demande.ID, formPrint.ID);
			};
			this.creationInstruction = (type, options) => {
				let toConfirm = true;
				Object.keys(this.user.droits).forEach((droit) => {
					if(droit === "AUCUNE_CONFIRMATION" || droit === "AUCUNE_CONFIRMATION_PROCEDURE"){
					  toConfirm = false;
					}
				  })
				if(options.confirm && toConfirm){
					this.createInstruction(type, options, toConfirm);
				}
				else
					this.createInstruction(type, options);

			}
			this.archiveDossier = (retour, options) => {
				if(options.confirm){
					
					let label:string=(this.dossier.archive!=undefined && this.dossier.archive==1) ? "Etes-vous sûr de vouloir désarchiver ce dossier ?":"Etes-vous sûr de vouloir archiver ce dossier ?"
					let dt:any={
						libelle : label
					}
					console.log("archiveDossier",dt);
					const confDialogRef = this.dialog.open(ConfirmComponent,{data :  dt});
					confDialogRef.afterClosed().subscribe(res => {
						if(res === 'true')
							this.archivateDossier(retour);
					});
				}else
					this.archivateDossier(retour);
			}	
		});
		
		this.stateService.droitsApp.subscribe((droits) => {
			if(droits === Object(droits))
			  this.droits = [droits];
			else
			  this.droits = droits;
		  });

		this.stateService.user.subscribe((user) => {
			if(user.droits === Object(user.droits))
			  this.userDroits = [user.droits];
			else
			  this.userDroits = user.droits;
			this.user = user;
		});
	}
	
	checkToAddButton(parameter:any,_params:any) {
	        let added:boolean=true;
			console.log("checkToAddButton before",added,_params,parameter)
			if (_params.type!=undefined 
				&& parameter.tiers_type!=undefined 
				&& parameter.tiers_type.length>0 ) {
	            added=false;
	            for(let i=0;i<parameter.tiers_type.length;i++) {
	                if (parameter.tiers_type[i]===_params.type)
	                   added=true;
	            }
	           console.log("checkToAddButton",added,_params.type,parameter.tiers_type)
	        }
	        return added;
	        
	}

	

	/**
	 * After view init
	 */
	ngAfterViewInit(): void {

		this.stateService.menu_item.subscribe((item:any) => {
				    	console.log("Subheader3Component init menu item",item);
					this.icon="la la-user";
					if (item.icon!=undefined)
						this.icon=item.icon;
					if (item.labels!=undefined
						&& item.labels.title!=undefined )
						this.title=item.labels.title;
						this.desc2=undefined;
				    if (item.labels!=undefined
						&& item.labels.description!=undefined )
						this.desc=item.labels.description;	
					this.dossierTitle=undefined;
					if (item.labels!=undefined
									&& item.labels.dossier!=undefined )
									this.dossierTitle=item.labels.dossier;		
						
				})
				
				
				this.stateService.dossier.subscribe((dossier) => {
					this.dossier = dossier;
					this.labelSub = "Actions";
					this.showAcces = () => {
						this.displayAcces();
					}
					console.log("Subheader3Component",this.dossier)
					
					if (/*this.title=="Dossier" 
						&& */this.dossier!=undefined 
						&&  this.dossier
						&&  this.dossier.tiers!=undefined
						&&  this.dossier.tiers.type_libelle!=undefined
					     )
						 this.title ="Dossier<br>"+this.dossier.tiers.type_libelle; 
						// this.title =(this.dossierTitle!=undefined)?  this.dossierTitle : this.dossier.tiers.type_libelle;
					//	this.title ="Dossier<br>"+this.dossier.tiers.type_libelle; 
					
					this.cdf.detectChanges();
		})
		
		/*this.subscriptions.push(this.subheaderService.title$.subscribe(bt => {
			// breadcrumbs title sometimes can be undefined
			if (bt) {
				
				Promise.resolve(null).then(() => {
					this.title = bt.title;
					if(bt.desc) {
						this.desc = bt.desc;
						this.desc2 = undefined;
					}
					console.log("Subheader3Component subheaderService",bt,this.dossier);
					if (this.title=="Dossier" 
						&& this.dossier!=undefined 
						&&  this.dossier
						&&  this.dossier.tiers!=undefined
						&&  this.dossier.tiers.type_libelle!=undefined
					     )
						 this.title =this.dossier.tiers.type_libelle; 
				});
			}
		}));
		*/
		this.subscriptions.push(this.subheaderService.breadcrumbs$.subscribe(bc => {
			Promise.resolve(null).then(() => {
				this.breadcrumbs = bc;
				
				if(this.breadcrumbs[0] && this.breadcrumbs[0].page == "mam")
					this.colorization = "mam-header";
				else if(this.breadcrumbs[0] && this.breadcrumbs[0].page == "eaje")
					this.colorization = "eaje-header";
				else
					this.colorization = "";
			});
		}));

		this.subscriptions.push(this.stateService.etats.subscribe((etats)=> {
			this.etats = [];
			_.forEach(etats, (etat, index)=> {
				let change = () => {
					this.changeState(etat.name, etat.label)
				}
				let formcall = () => {
					this.loadForm(this.demande.type.ID, etat.form.key, this.demande.ID, etat.name)
				}
				if(!etat.form){
					this.etats.push({
						icon : '',
						libelle : etat.label,
						etatId: etat.name,
						etatLabel: etat.label,
						action : change
					})
				}
				else
				{
					this.etats.push({
						icon : '',
						libelle : etat.label,
						etatId: etat.name,
						etatLabel: etat.label,
						action : formcall
					});
				}
			});
			if(this.etats.length > 0){
				this.quickmenu.push({
					page : 'assistmat',
					icon : 'la la-exchange',
					libelle : 'Changement état',
					link : 'etats',
					children : this.etats
				});
			}
			this.utilities.log(this.etats, this.quickmenu);
		}));

		this.stateService.subHeader.subscribe((res) => {
			this.desc = res;
		});
		
		this.stateService.subHeader2.subscribe((res) => {
					this.desc2 = res;
		});
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this.subscriptions.forEach(sb => sb.unsubscribe());
	}
	getCourrier(iddemande: string, codeform: string): void {
		const dialogRef = this.dialog.open(CourrierDialog, {
			data: {
			  typeDemande : this.demande,
			  state:	this.currentState
			}
		  });

		dialogRef.afterClosed().subscribe(result => {
			if(result){
			}
		});
	}
	getImpression(code:string, iddemande: string, formId: string): void {
		this.appService.getImpression(iddemande, code, formId).then((impression) => {
			window.open(impression.result[0].url, '_blank');
		});
	}
	changeState(idTransition: string, labelTransition): void {
		of(window.confirm("Voulez-vous changer l'état de la demande vers "+labelTransition)).subscribe((bool) => {
			if(bool){
				this.appService.changeEtatDemande(this.demande.ID, idTransition).then((result) => {
					this.router.navigate(['/home/assistmat/'+this.demande.dossier.ID]);
				})
			}
		})
	}
	loadForm(typeDemande: string, typeForm: string, idDemande: string, etat: string): void {
		this.router.navigate(['/home/formulaire/'+typeDemande+"/"+typeForm+"/"+idDemande+"/"+etat]);
	}
	returnToDossier(){
		let id = this.demande.dossier.ID;
		if(this.demande.dossier.tiers.type == "ASSMAT"){
			this.stateService.updateDemande("");
			this.router.navigate(['home/assistmat'+'/'+id]);

		}
	}
	createInstruction(type: string, options ?: any, toConfirm: boolean = false): void{
		this.appService.getTypeInstruction().subscribe((res) => {
			console.log(res, type);
			if(res && res.result){
				let toAdd = true;
				res.result.forEach(element => {
					if(element.key === type && element.demande_type.length > 1 && toAdd){
						toAdd = false;
						console.log("ouverture popup",type)
						const confDialogRef = this.dialog.open(DemandeInstructionDialogComponent, {
							data : {
								demandes : element.demande_type,
								demande: options.demande_type
							},
							width : "30vw",
							height : "31vh"
						});
						confDialogRef.afterClosed().subscribe(res => {
							if(res && res.ID){
								options.demande_type = res.ID;
								this.processInstructionAndRefresh(type,options)
							}
						});
					}
				});
				if(toAdd){
					if(toConfirm){
						const confDialogRef = this.dialog.open(ConfirmComponent, {});
						confDialogRef.afterClosed().subscribe(res => {
							if(res === 'true'){
								this.processInstructionAndRefresh(type,options)
							}
						});
					}
					else{
						this.processInstructionAndRefresh(type,options)
					}
				}
			}
		});
	}

	processInstructionAndRefresh(type,options){
		this.appService.getNewInstruction(type, options).subscribe((res) => {
			console.log("subharder3 getNewInstruction",this.dossier,type,options)
			if(this.dossier.instructions==undefined || !this.dossier.instructions)
					this.dossier.instructions = [];
			this.appService.createNewInstruction(type, this.dossier.ID, res.result, options).subscribe((resCreate) => {
				this.dossier.instructions.unshift(resCreate.result);
				this.stateService.updateDossier(this.dossier);
				var refreshType = "instruction";
				if (options.index_tab) {
					console.log("___test",type,options,isNaN(options.index_tab))
					if(isNaN(options.index_tab)){
						refreshType = options.index_tab
					}
					else{
						if (options.index_tab==4)
							refreshType="suivi";
					}
				}
				let _refresh={
					type: refreshType,
					data:resCreate.result
				};										
						
				this.stateService.updateRefresh(_refresh);
				this.stateService.selectNewCreatedInstruction(resCreate.result)
				console.log("created",resCreate.result,_refresh);

			});
		});
	}

	archivateDossier(retour): void {
		this.appService.archivateDossier(this.dossier.ID).subscribe((res) => {
			this.router.navigate(['/home/'+retour]);
		});
	}
	displayAcces(): void{
		console.log("Subheader3Component AccesComponent",this.dossier);
		
		let email:string='';
		
		if (this.dossier.access !=undefined
			 && this.dossier.access.email !=undefined )
			 email=this.dossier.access.email;
	    else if ( this.dossier.tiers !=undefined
			 	&& this.dossier.tiers.contacts !=undefined 
				&& this.dossier.tiers.contacts.EMAIL !=undefined 
			)
			 email=this.dossier.tiers.contacts.EMAIL;
		const dialogRef = this.dialog.open(AccesComponent,{
			data: {
				id: this.dossier ? this.dossier.ID : 0,
				email : email,
				email_valid : this.dossier.access ? this.dossier.access.email_valid : false,
				password : this.dossier.access ? this.dossier.access.passe : false
			}
		  });
	  
		  dialogRef.afterClosed().subscribe(result => {
			if(result){
			  this.utilities.log(result);
			}
		  });
	}
	displayDoublon(): void{
		const dialogRef = this.dialog.open(DoublonComponent,{
			data: {
				id: this.dossierWeb ? this.dossierWeb.tiers.ID : 0,
			},
			height:"80vh",
			width:"80vw"
		  });
	  
		  dialogRef.afterClosed().subscribe(result => {
			if(result){
			  this.utilities.log(result);
			  this.snackBar.open("Changement effectué");
			  this.router.navigate(['/home/webamat']);
			}
		  });
	}
	getFormulaire(type: string, page: any): void{
		const dialogRef = this.dialog.open(FormDialogFormulaireWithSFComponent,{
			data: {
			  typeFormulaire: type,
			  dossierId: '',
			  dossier:this.dossier,
			  create: true,
			  closeWhenValidate: true
			},
			height:"90vh",
			width:"80vw"
		  });
	  
		  dialogRef.afterClosed().subscribe(result => {
			if(result!=undefined  
			&& result.result!=undefined && 
			result.result){
			  this.utilities.log(result.result);
			  this.stateService.updateRefresh('Success');
			  if(page.redirect && result.result.demande.dossier.ID)
			 	 this.router.navigate(['/home/'+page.redirect+'/'+result.result.demande.dossier.ID]);		
			}
		  });
	}
	
	CheckDroitsApplication(type: any, element:any, action: any): boolean{
		let response = true;
		let selectedDroit;
		if(this.droits && this.droits.length > 0 && element){
		  this.droits.forEach((droit) => {
			droit.acces.forEach((acces) => {
			  if(acces.instruction && element === acces.instruction.key && ! acces.demande_type && !acces.instruction_etat){
				selectedDroit = acces;
			  }
			})
		  });
		}
		if(type === "instruction" && selectedDroit && selectedDroit.instruction)
		{
			if(!selectedDroit.demande_type && !selectedDroit.instruction_etat && !selectedDroit.form && !selectedDroit.document && !selectedDroit.courrier && selectedDroit.instruction.key === element)
				response = selectedDroit[action];
			if(action === "u" && !_.isEmpty(this.dossier))
			{
			}
		}
		return response;
	  }

	CheckDroitsUser(): boolean{
		let response = true;
		if(this.userDroits && this.userDroits.length > 0){
			Object.keys(this.userDroits[0]).forEach((userDroitIndex) => {
				if(this.router.url.toUpperCase().indexOf(userDroitIndex) !== -1){
					response = this.userDroits[0][userDroitIndex].w; 
				}
			});
		}
		return response;
	}
	
	getTypeList() {
   		let types:string[]=[];
		if (this.dossier!=undefined && this.dossier.tiers!=undefined && this.dossier.tiers.type!=undefined)
   			types.push(this.dossier.tiers.type);
		//console.log("Subheader3Component getTypeList",this.dossier.tiers.type,types);
		   		
   		return types;
	   	}
}
